import { useEffect, useState, useContext } from 'react';
import { useFormikContext } from 'formik';
import CurrencyField from 'src/components/util/CurrencyField';
import ValueTaxDataTable from 'src/components/util/ValueTaxDataTable';
import PropValAndTaxInfoContext from 'src/contexts/prop-val-and-tax-info';
import removeCurrencyFormat from 'src/util/removeCurrencyFormat';

export default function NonMotorVehiclePropertyValueAndTaxInfo() {
  const { assets, onRowClick, handleOpen } = useContext(PropValAndTaxInfoContext);

  const [amountPaid, setAmountPaid] = useState(0);
  const form = useFormikContext();

  const handleFieldChange = (field, val) => {
    form.setFieldValue(field, val);
  };

  useEffect(() => {
    const updatedAmountPaid = assets.reduce((prev, cv) => {
      return Number(prev) + Number(removeCurrencyFormat(cv.total));
    }, 0);
    setAmountPaid(updatedAmountPaid.toFixed(2));
    handleFieldChange('valueAndTaxInfo.assets', [...assets]);
    handleFieldChange('valueAndTaxInfo.amountPaid', amountPaid);
  }, [assets]);

  return (
    <>
      <ValueTaxDataTable
        addAsset={handleOpen}
        onRowClick={onRowClick}
        rows={assets}
        toolbar
        total={amountPaid}
      />
      <div className="flex flex-col gap-6">
        <CurrencyField
          label="Current year market value of property (most recent valuation / tax notice to be attached)"
          name="valueAndTaxInfo.currMarketValue"
          onChange={handleFieldChange}
        />
        <CurrencyField
          label="Amount Owner Offers in Settlement"
          name="valueAndTaxInfo.amountOfferedInSettlement"
          onChange={handleFieldChange}
        />
        <CurrencyField
          label="Amount to be abated/refunded"
          name="valueAndTaxInfo.amountToBeRefunded"
          onChange={handleFieldChange}
        />
      </div>
    </>
  );
}
